var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.option)?_c('div',[_c('figure',{staticClass:"image is-4by3 mb-4"},[_c('ImgLoader',{staticClass:"has-background-grey-light",attrs:{"src":_vm.option.Image,"type":"location","typeId":_vm.locationId}})],1),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }